import { Taxonomy } from '../generated';

export type MicrobiomeTaxonomy = Partial<{ [key in Taxonomy]: string }>;

export const TaxonomyOrder: Taxonomy[] = [
  Taxonomy.kingdom,
  Taxonomy.phylum,
  Taxonomy.class,
  Taxonomy.order,
  Taxonomy.family,
  Taxonomy.genus,
  Taxonomy.species,
];
